module.exports = __webpack_public_path__ + "assets/img/resource-praise.d941449c.svg";